import GridViewController from './grid-view.controller';
import { GridViewProps } from './grid-view.model';

const GridView = (props: GridViewProps) => {
  return <GridViewController {...props} />;
};

export default GridView;
